import { Alert, Col, Skeleton, Space } from "antd";

import { SearchInput } from "components/Shared/SearchInput";
import { SectionWithHeading } from "components/Shared/SectionWithHeading";
import type { ReactNode } from "react";

type Validation = {
  check: () => boolean;
  message: string;
};

type Props = {
  isLoading: boolean;
  items: Array<any>;
  validations?: Array<Validation>;
  title?: string;
  onSearch?: (searchText: string) => void;
  render: (item: any) => ReactNode;
};

export const SelectTable = ({ isLoading, items, validations, title, onSearch, render }: Props) => {
  if (isLoading) {
    return (
      <Col span={4}>
        <Skeleton paragraph={{ rows: 4 }} />
      </Col>
    );
  }

  if (validations && validations.length > 0) {
    for (let i = 0; i < validations.length; i++) {
      const validation = validations[i];
      if (validation?.check()) {
        return <Alert type="error" description={validation.message} />;
      }
    }
  }

  return (
    <Col xs={24} sm={10} md={12} lg={10} xl={8} xxl={5}>
      <SectionWithHeading heading={title || ""}>
        <div
          style={{
            boxShadow: "rgba(0, 0, 0, 0.12) 0px 12px 40px",
            padding: "10px",
            marginTop: "10px",
          }}
        >
          {onSearch && <SearchInput className="mb-10" onSearch={onSearch} />}
          <Space direction="vertical" style={{ width: "100%", maxHeight: "400px", overflow: "auto" }}>
            {items?.map((item) => render(item))}
          </Space>
        </div>
      </SectionWithHeading>
    </Col>
  );
};
